import { render, staticRenderFns } from "./PersonProfileMasterRecordHighlights.vue?vue&type=template&id=6b0b92b4&scoped=true&"
import script from "./PersonProfileMasterRecordHighlights.vue?vue&type=script&lang=js&"
export * from "./PersonProfileMasterRecordHighlights.vue?vue&type=script&lang=js&"
import style0 from "./PersonProfileMasterRecordHighlights.vue?vue&type=style&index=0&id=6b0b92b4&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b0b92b4",
  null
  
)

export default component.exports